"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateAttendanceStatusDtoAttendanceStatusEnum = void 0;
exports.instanceOfUpdateAttendanceStatusDto = instanceOfUpdateAttendanceStatusDto;
exports.UpdateAttendanceStatusDtoFromJSON = UpdateAttendanceStatusDtoFromJSON;
exports.UpdateAttendanceStatusDtoFromJSONTyped = UpdateAttendanceStatusDtoFromJSONTyped;
exports.UpdateAttendanceStatusDtoToJSON = UpdateAttendanceStatusDtoToJSON;
exports.UpdateAttendanceStatusDtoToJSONTyped = UpdateAttendanceStatusDtoToJSONTyped;
/**
 * @export
 */
exports.UpdateAttendanceStatusDtoAttendanceStatusEnum = {
    Pending: 'pending',
    Attended: 'attended',
    Unattended: 'unattended'
};
/**
 * Check if a given object implements the UpdateAttendanceStatusDto interface.
 */
function instanceOfUpdateAttendanceStatusDto(value) {
    if (!('attendanceStatus' in value) || value['attendanceStatus'] === undefined)
        return false;
    return true;
}
function UpdateAttendanceStatusDtoFromJSON(json) {
    return UpdateAttendanceStatusDtoFromJSONTyped(json, false);
}
function UpdateAttendanceStatusDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'attendanceStatus': json['attendanceStatus'],
    };
}
function UpdateAttendanceStatusDtoToJSON(json) {
    return UpdateAttendanceStatusDtoToJSONTyped(json, false);
}
function UpdateAttendanceStatusDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'attendanceStatus': value['attendanceStatus'],
    };
}
